import {
    URLAPI,
    SERVICE_VEHICLE_MAINTENANCE_CREATE_PATH,
    SERVICE_VEHICLE_MAINTENANCE_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _create_service_vehicle_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_service_vehicle_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
};

export const CREATE_SERVICE_VEHICLE_MAINTENANCE = "CREATE_SERVICE_VEHICLE_MAINTENANCE";
export const DELETE_SERVICE_VEHICLE_MAINTENANCE = "DELETE_SERVICE_VEHICLE_MAINTENANCE";

export const service_vehicle_maintenance_module = (state = init, action) => {
    switch (action.type) {
        case CREATE_SERVICE_VEHICLE_MAINTENANCE:
            return {
                ...state,
                _create_service_vehicle_maintenance: action.payload,
            };
        case DELETE_SERVICE_VEHICLE_MAINTENANCE:
            return {
                ...state,
                _delete_service_vehicle_maintenance: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};


export const createServiceVehicleMaintenance = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${SERVICE_VEHICLE_MAINTENANCE_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_SERVICE_VEHICLE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_SERVICE_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_SERVICE_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteServiceVehicleMaintenance = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${SERVICE_VEHICLE_MAINTENANCE_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_SERVICE_VEHICLE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_SERVICE_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_SERVICE_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_service_vehicle_maintenance = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
